import { formatMonitoringPercent } from 'containers/user/critical-elements-monitoring/helpers/format-monitoring-value';
import { NO_VALUE_GLYPH } from 'containers/user/critical-elements-monitoring/monitoring-constants';

export interface CriticalElementSummaryStatProps {
  label: string;
  value: number | undefined;
  totalVolume: number | undefined;
  isLoading: boolean;
}

const PERCENT_SCALE = 100;

const CriticalElementSummaryStat = ({
  label,
  value,
  totalVolume,
  isLoading,
}: CriticalElementSummaryStatProps) => {
  const renderValue = () => {
    if (value !== undefined) return value.toLocaleString();

    if (isLoading) {
      return (
        <span className="block h-3 w-10 animate-pulse rounded bg-gray-100" />
      );
    }

    return NO_VALUE_GLYPH;
  };

  return (
    <span className="flex flex-col items-end">
      <span className="text-xs font-semibold text-gray-500">{label}</span>
      <span className="flex min-h-5 items-center text-sm font-bold text-gray-700">
        {renderValue()}
      </span>
      {totalVolume === undefined && isLoading ? (
        <span className="flex h-4 items-center">
          <span className="block h-3 w-14 animate-pulse rounded bg-gray-100" />
        </span>
      ) : (
        <span className="block h-4 text-xs text-gray-500">
          {value !== undefined && totalVolume
            ? `${formatMonitoringPercent(
                (value / totalVolume) * PERCENT_SCALE
              )} of total`
            : ''}
        </span>
      )}
    </span>
  );
};

export default CriticalElementSummaryStat;
